import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  dark = false,
  delay = 0
}: SectionProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-10% 0px'
  });
  return <section id={id} ref={ref} className={`relative py-6 md:py-8 overflow-hidden ${dark ? 'bg-[#0f4c3a] text-[#f4e5c3]' : 'bg-[#fcfbf7] text-slate-800'} ${className}`} data-id="element-236">
      {/* Background texture/gradient elements could go here */}

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8,
      ease: 'easeOut',
      delay
    }} className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10" data-id="element-237">
        {children}
      </motion.div>
    </section>;
}